import { useEffect, useState } from "react";

import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";

export const Onboarding = ({ userData, supabase, handleSnackbar }) => {
  const [step1Completed, setStep1Completed] = useState(false);
  const [step2Completed, setStep2Completed] = useState(false);
  const [step3Completed, setStep3Completed] = useState(false);

  useEffect(() => {
    if (userData?.email) {
      setStep1Completed(true);
    }
  }, []);

  return (
    <div className="standard-container-2" style={{ maxWidth: "750px" }}>
      <Step1
        step1Completed={step1Completed}
        setStep1Completed={setStep1Completed}
        supabase={supabase}
        handleSnackbar={handleSnackbar}
      />
      <Step2
        step1Completed={step1Completed}
        step2Completed={step2Completed}
        setStep2Completed={setStep2Completed}
        userData={userData}
      />
      <Step3
        step1Completed={step1Completed}
        step2Completed={step2Completed}
        step3Completed={step3Completed}
        setStep3Completed={setStep3Completed}
      />
      <div style={{ height: "50px" }} />
    </div>
  );
};
